/* eslint-disable react/display-name */
import { forwardRef } from 'react';
import { BETabPanelProps } from './BETabPanelProps';
import styled from '@emotion/styled';

const StyledTabPanel = styled.div`
  padding: 24px 0;
`;

const BETabPanel = forwardRef<HTMLDivElement, BETabPanelProps>(
  ({ children, tabId, ...rest }, ref) => {
    return (
      <StyledTabPanel
        {...rest}
        aria-labelledby={tabId}
        ref={ref}
        role="tabpanel"
        tabIndex={0}
      >
        {children}
      </StyledTabPanel>
    );
  }
);

export default BETabPanel;
